@if (actions) {
  @if (anchored) {
    <!-- Anchored to the control that opened it (ActionArgs.anchor): the reaction picker's surface. -->
    <div
      #menu
      class="action-menu"
      role="menu"
      [attr.aria-label]="title || 'options'"
      [class.action-menu--show]="show"
      [class.action-menu--above]="menuAbove"
      [style.top.px]="menuTop"
      [style.left.px]="menuLeft"
      [style.max-height.px]="menuMaxHeight"
      (keydown)="onMenuKeydown($event)"
    >
      @if (title) {
        <div class="action-menu__title" [innerHTML]="title | safe: 'html'"></div>
      }
      @for (action of actions; track action.label) {
        @if (action.divider) {
          <hr class="action-menu__divider" role="separator" />
        }
        <button type="button" role="menuitem" class="action-menu__item" [class.action-menu__item--iconed]="hasIcons" (click)="choose(action.label, $event)">
          @if (hasIcons) {
            <span class="action-menu__icon" aria-hidden="true">
              @if (action.icon) {
                <fa-icon [icon]="action.icon" [fixedWidth]="true"></fa-icon>
              }
            </span>
          }
          <span class="action-menu__label" [innerHTML]="action.label | safe: 'html'"></span>
        </button>
      }
    </div>
  } @else {
    <div class="action-chooser-container" appTrapFocus [show]="show" (click)="choose(false)" #modal [class.hide]="!show" [class.show]="show" role="dialog" aria-modal="true" aria-label="post options">
      <div class="action-list">
        @if (title) {
          <div class="action-title" [innerHTML]="title | safe: 'html'"></div>
        }
        @for (action of actions; track action.label) {
          @if (action.divider) {
            <hr class="action-divider" role="separator" />
          }
          <button class="btn btn-transparent btn-block action-item" (click)="choose(action.label, $event)">
            @if (action.icon) {
              <fa-icon class="action-item__icon" [icon]="action.icon" [fixedWidth]="true" aria-hidden="true"></fa-icon>
            }
            <span [innerHTML]="action.label | safe: 'html'"></span>
          </button>
        }
        <button class="btn btn-transparent btn-block action-item cancel" (click)="choose(false, $event)">{{ "sphere.cancel" | translate }}</button>
      </div>
    </div>
  }
}
